__turbopack_context__.v({
  "online": "index-module-scss-module__nZH8wq__online",
  "presence_status": "index-module-scss-module__nZH8wq__presence_status",
});
